import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Layout.css';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="brand">
            <img src="/kaammytra-logo.png" alt="KaamMytra" className="logo" />
            <h2>kaammytra</h2>
          </div>
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            ☰
          </button>
        </div>

        <nav className="sidebar-nav">
          <a href="/dashboard" className="nav-item">
            <span className="icon">📊</span>
            <span>Dashboard</span>
          </a>
          <a href="/loans" className="nav-item">
            <span className="icon">📋</span>
            <span>Loans</span>
          </a>
          <a href="/retailers" className="nav-item">
            <span className="icon">🏪</span>
            <span>Retailers</span>
          </a>
          <a href="/loan-types" className="nav-item">
            <span className="icon">🏷️</span>
            <span>Loan Types</span>
          </a>
          <a href="/agents" className="nav-item">
            <span className="icon">👥</span>
            <span>Agents</span>
          </a>
          <a href="/agent-collection-summary" className="nav-item">
            <span className="icon">📊</span>
            <span>Agent Collections</span>
          </a>
          <a href="/retailer-details" className="nav-item">
            <span className="icon">📈</span>
            <span>Retailer Details</span>
          </a>
          <a href="/collection-history" className="nav-item">
            <span className="icon">📜</span>
            <span>Collection History</span>
          </a>
          <a href="/reports" className="nav-item">
            <span className="icon">📈</span>
            <span>Reports</span>
          </a>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        {/* Header */}
        <header className="header">
          <div className="header-left">
            <button
              className="menu-button"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              ☰
            </button>
          </div>

          <div className="header-right">
            <div className="user-info">
              <span className="user-name">
                {user?.firstName} {user?.lastName}
              </span>
              <button className="logout-button" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
